module.exports = __webpack_public_path__ + "static/media/sonarqube-integration-with-nodejs-app.2fad195d.md";